// src/redux/allReducer/rootReducer.js
import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { appCreationReducer } from "./appCreationReducer";
import { botContentReducer } from "./botContentReducer";
import { planReducer } from "./planReducer";
import tenantPlanReducer from "./tenantPlanReducer";


const rootReducer = combineReducers({
  auth: authReducer,
  appCreation: appCreationReducer,
  tenantPlan: tenantPlanReducer, 
  plan: planReducer,
  botContent: botContentReducer,
});

export default rootReducer;